module.exports = __webpack_public_path__ + "img/icon-act.f0aeff6c.svg";